module.exports = __webpack_public_path__ + "static/media/youtube.a4faa3b5.svg";